import { render } from "./App.vue?vue&type=template&id=0da0fcb3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/scss/branding-styles.scss?vue&type=style&index=0&lang=scss&external"
import "./styles/theme.scss?vue&type=style&index=1&lang=scss&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__